<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/bank")
          i.fa.fa-landmark
          span.ml-1 {{ $t("ui.bank") }}
      b-breadcrumb-item
        router-link(to="/bank/bankOperator")
          i.fas.fa-landmark
          span.ml-1 {{ $t("ui.bank_operator") }}
  .row
    .col-md-12
      .row.mb-1
        .col-lg-5.col-md-12
          .d-flex.align-items-center.justify-content-end.mb-1
            b-input-group(size="sm").mr-1
              b-input-group-text(slot="prepend")
                i.icon-question
              b-form-select(v-model="bankAccStatus" @change="getBankAccList(true)" :disabled="loading")
                option(value=0) {{ $t('ui.all') }}
                option(value=1) {{ $t('ui.active') }}
                option(value=-1) {{ $t('ui.inactive') }}
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                i.icon-info
              b-form-select(v-model="bankAccType" @change="getBankAccList(true)" :disabled="loading")
                option(value="") {{ $t('ui.all') }}
                option(value="BOTH") {{ $t('ui.both') }}
                option(value="INCOMING") {{ $t('ui.incoming') }}
                option(value="OUTGOING") {{ $t('ui.outgoing') }}
        .col-lg-7.col-md-12
          .d-flex.align-items-center.justify-content-end.mb-1
            b-button.btn-brand(
              v-b-modal.addBankAccount
              type="button"
              variant="info"
              size="sm"
              :disabled="loading"
              ).mr-1
              i.fa.fa-plus
              span {{ $t("ui.add_account") }}
            b-button.btn-brand(v-b-modal.editBankSetting type="button" variant="info" size="sm" :disabled="loading").mr-1
              i.fas.fa-cog
              span {{ $t("ui.settings") }}
            b-button.btn-brand(v-b-modal.bankTransfer type="button" variant="info" size="sm" :disabled="loading")
              i.fas.fa-exchange-alt
              span {{ $t("ui.bank_transfer") }}

  .row
    .col-md-12
      .card.mb-1
        .card-header.p-2.bg-gradient-light
        .card-body.p-1
          .row.mb-1
            .col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            .col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          .row
            .col-md-12
              .table-responsive
                table.table.b-table.c-table
                  thead
                    tr
                      //- th(width="40px")
                      //-   .text-center
                      //-     span #
                      th.sortable(@click="sortOrder('bank_acc_no')")
                        .d-block.text-left.cursor-pointer
                          span {{ $t("ui.short.bank_acc_no") }} @ {{ $t("ui.short.bank_acc_holder") }}
                          i(:class="changeSortKey('bank_acc_no')")
                        .d-block.text-left
                          span {{ $t("ui.bank_name") }}
                        //- .d-block.text-left
                        //-   span {{ $t("ui.short.bank_acc_holder") }}
                      th(width="60px")
                        .text-center
                          span {{ $t("ui.status") }}
                      th(width="85px")
                        .text-left
                          span {{ $t("ui.action") }}
                      th(width="160px")
                        .text-right
                          span {{ $t("ui.short.account_balance") }}
                        .text-right
                          span {{ $t("ui.short.bank_acc_type") }}
                      th(width="160px")
                        .text-right
                          span {{ $t("ui.short.incoming_threshold") }}
                      th(width="160px")
                        .text-right
                          span {{ $t("ui.short.incoming_frequency") }}
                      th(width="160px")
                        .text-right
                          span {{ $t("ui.short.outgoing_threshold") }}
                      th(width="160px")
                        .text-right
                          span {{ $t("ui.short.outgoing_frequency") }}
                      //- th(width="8%")
                      //-   .text-right
                      //-     span {{ $t("ui.created_date") }}
                  tbody
                    tr(v-if="bankAccountList.length == 0")
                      td(colspan="13").text-center
                        span.text-zero {{ $t('message.no_records') }}
                    tr(v-for="(item, index) in bankAccountList")
                      //- td
                      //-   .text-center
                      //-     span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        .d-block.text-left.text-primary.text-truncate
                          span #[b {{ item.bank_acc_no }}] @
                          b.text-zero {{ item.bank_acc_holder }}
                        .d-block.text-left.text-info
                          span {{ item.bank_name }}
                        //- .d-block.text-left.text-zero
                        //-   span {{ item.bank_acc_holder }}
                      td
                        .d-flex.align-items-center.justify-content-center
                          label.switch.switch-label.switch-info.switch-sm.m-0
                            input.switch-input(type="checkbox" v-model="item.status" @change="changedBankAccStatus(item, $event)")
                            span.switch-slider(:data-checked='on' :data-unchecked='off')
                      td
                        .d-flex.align-items-center.justify-content-start
                          b-link.action-item.fa.fa-edit.text-primary(
                            href="javascript:;"
                            :title="$t('ui.edit')"
                            @click="onEdit(item)"
                            )
                          b-link.action-item.fa.fa-sync.text-primary.action-secondary(
                            href="javascript:;"
                            :title="$t('ui.reset_threshold')"
                            @click="onReset(item)"
                            )
                          b-link.action-item.fa.fa-sliders-h.text-primary.action-secondary(
                            href="javascript:;"
                            :title="$t('ui.bank_adjust')"
                            @click="onAdjust(item)"
                            )
                      td
                        .d-block.text-right
                          span(
                            :class="$helpers.getNumberClass(item.account_balance)"
                            )
                            | #[b {{ item.account_balance | currency }}]
                        .d-block.text-right.text-zero
                          span {{ item.bank_acc_type }}
                      td(
                        :class="{ 'red-bg': isShowAlert(item.accumulate_incoming_amount, item.incoming_amount_threshold) && item.bank_acc_type.toUpperCase() != 'OUTGOING' }"
                        )
                        .d-block.text-center.text-zero(v-if="item.bank_acc_type.toUpperCase() == 'OUTGOING'") -
                        template(v-else)
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.accumulate_incoming_amount)"
                              )
                              | #[b {{ item.accumulate_incoming_amount | currency }}]
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.incoming_amount_threshold)"
                              )
                              | #[b {{ item.incoming_amount_threshold | currency }}]
                      td(
                        :class="{'red-bg': isShowAlert(item.accumulate_incoming_frequency, item.incoming_frequency_threshold) && item.bank_acc_type.toUpperCase() != 'OUTGOING'}"
                        )
                        .d-block.text-center.text-zero(v-if="item.bank_acc_type.toUpperCase() == 'OUTGOING'") -
                        template(v-else)
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.accumulate_incoming_frequency)"
                              )
                              | #[b {{ item.accumulate_incoming_frequency | currency }}]
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.incoming_frequency_threshold)"
                              )
                              | #[b {{ item.incoming_frequency_threshold | currency }}]
                      td.text-center(
                        :class="{'red-bg': isShowAlert(item.accumulate_outgoing_amount, item.outgoing_amount_threshold) && item.bank_acc_type.toUpperCase() != 'INCOMING'}"
                        )
                        .d-block.text-center.text-zero(v-if="item.bank_acc_type.toUpperCase() == 'INCOMING'") -
                        template(v-else)
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.accumulate_outgoing_amount)"
                              )
                              | #[b {{ item.accumulate_outgoing_amount | currency }}]
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.outgoing_amount_threshold)"
                              )
                              | #[b {{ item.outgoing_amount_threshold | currency }}]
                      td.text-center(
                        :class="{'red-bg': isShowAlert(item.accumulate_outgoing_frequency, item.outgoing_frequency_threshold) && item.bank_acc_type.toUpperCase() != 'INCOMING'}"
                        )
                        .d-block.text-center.text-zero(v-if="item.bank_acc_type.toUpperCase() == 'INCOMING'") -
                        template(v-else)
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.accumulate_outgoing_frequency)"
                              )
                              | #[b {{ item.accumulate_outgoing_frequency | currency }}]
                          .d-block.text-right
                            span(
                              :class="$helpers.getNumberClass(item.outgoing_frequency_threshold)"
                              )
                              | #[b {{ item.outgoing_frequency_threshold | currency }}]


                      //- td.text-right
                      //-   span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}


    addbankaccount(@clicked="addBankAccount" @failed="handleFailed")
    editbanksetting(@clicked="editBankSetting" @failed="handleFailed")
    editbankaccount(ref="editbankaccount" :item="editSelectedBankAccount" @clicked="afterEditBankAccount" @failed="handleFailed")
    resetthreshold(ref="resetthreshold" :item="editSelectedBankAccount" @clicked="afterResetThreshold" @failed="handleFailed")
    banktransfer(ref="banktransfer" @clicked="afterBankTransfer" @failed="handleFailed")
    bankadjust(ref="bankadjust" :item="editSelectedBankAccount" @clicked="afterBankAdjust" @failed="handleFailed")
  #end-report.mt-3
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addbankaccount from "@/components/bank/addBankAccount.vue";
import editbankaccount from "@/components/bank/editBankAccount.vue";
import resetthreshold from "@/components/bank/resetThreshold.vue";
import editbanksetting from "@/components/bank/editBankSetting.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import banktransfer from "@/components/bank/bankTransfer.vue";
import bankadjust from "@/components/bank/bankAdjust.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addbankaccount,
    editbankaccount,
    resetthreshold,
    editbanksetting,
    banktransfer,
    bankadjust
  },
  data: () => ({
    loading: false,
    bankAccountList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "bank_acc_no",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedBankAccount: null,
    bankAccStatus: 1,
    bankAccType: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    }
  },
  mounted() {
    this.getBankAccList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key) this.sortType = this.sortType == "asc" ? "desc" : "asc";
      else {
        this.sortKey = key;
        this.sortType = "asc";
      }

      this.getBankAccList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key) return "fas fa-sort";
      else if (this.sortKey == key && this.sortType == "asc") return "fa fa-sort-up";
      else if (this.sortKey == key && this.sortType == "desc") return "fa fa-sort-down";
      this.getBankAccList(true);
    },
    isShowAlert(accumulate, threshold) {
      if (threshold <= 0) {
        return false;
      } else {
        if (parseFloat(accumulate) >= parseFloat(threshold)) return true;
      }

      return false;
    },
    afterEditBankAccount(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.edit_bank_account"), this.$t("message.success"), "success");
    },
    afterResetThreshold(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.reset_threshold"), this.$t("message.success"), "success");
    },
    afterBankTransfer(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.bank_transfer"), this.$t("message.success"), "success");
    },
    afterBankAdjust(item) {
      this.getBankAccList();
      this.$helpers.showDialog(this.$t("ui.bank_adjust"), this.$t("message.success"), "success");
    },
    onEdit(e) {
      this.editSelectedBankAccount = e;
      this.$refs.editbankaccount.$refs.editBankAccount.show();
    },
    onReset(e) {
      this.editSelectedBankAccount = e;
      this.$refs.resetthreshold.$refs.resetThreshold.show();
    },
    onAdjust(e) {
      this.editSelectedBankAccount = e;
      this.$refs.bankadjust.$refs.bankAdjust.show();
    },
    getBankAccList(isSearch) {
      if (isSearch) this.currentPage = 1;

      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.bankAccType.trim() != "") {
        args["bank_acc_type"] = this.bankAccType;
      } else {
        args["bank_acc_type"] = "";
      }

      if (this.bankAccStatus == 1) {
        args["bank_status"] = true;
      } else if (this.bankAccStatus == -1) {
        args["bank_status"] = false;
      } else {
        args["bank_status"] = null;
      }
      this.feedback.success = true;
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.bankList)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;

          if (this.feedback.success == true) {
            this.bankAccountList = res.data.bank_list;
            this.totalRow = this.bankAccountList.length > 0 ? this.bankAccountList[0].totalrows : 0;
          } else {
            if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        });
    },
    changedBankAccStatus(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_bank_account_status_confirm", { name: item.bank_acc_no }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmBankAccStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmBankAccStatus(item, status) {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        bank_id: item.bank_id,
        bank_acc_no: item.bank_acc_no,
        new_status: status
      };
      this.feedback.success = true;
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.updateBankStatus)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;

          if (this.feedback.success == true) {
            this.getBankAccList();
            this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
          } else {
            if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        })
        .catch(res => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        });
    },
    editBankSetting() {
      this.$helpers.showDialog(this.$t("ui.configure_bank_setting"), this.$t("message.success"), "success");
    },
    addBankAccount() {
      this.getBankAccList(true);

      this.$helpers.showDialog(this.$t("ui.add_bank_account"), this.$t("message.success"), "success");
    },
    edit(item) {
      this.bankAccountList.filter(function(info) {
        if (info.account_id == item.account_id) {
          info.full_name = item.full_name;
          info.contact_phone = item.contact_phone;
          info.contact_email = item.contact_email;
          info.dob = item.dob;
          info.mail_address = item.mail_address;
        }
      });

      this.$helpers.showDialog(this.$t("ui.edit_bank_account"), this.$t("message.success"), "success");
    },
    changedPageSize(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getBankAccList(true);
    },
    changedPage(pageNo) {
      this.currentPage = pageNo;
      this.getBankAccList();
    },
    handleFailed(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
hr {
  margin-top: 0em !important;
  margin-bottom: 0em !important;
  width: 50% !important;
}

.red-bg {
  background-color: #f7edef !important;
}
// .red-bg .text-primary {
//   color: #860148 !important;
// }

// .red-bg .text-zero {
//   color: #bea1b0 !important;
// }

td {
  vertical-align: middle !important;
}
</style>
